import React from "react";
import { Text4 } from "../../../../styles";
import { Icon, Button, Menu, Dropdown, Badge } from "antd";
import { PermissionHoc } from "../../../HOC";
import { VENDOR_APPROVAL_STATUS } from "../../../../constants";

const PermissableMenuItem = PermissionHoc(Menu.Item, "", {
  is_component: true,
  fallbackComponent: null,
});

export const renderMenuOverlay = (methods, record) => {
  return (
    <Menu>
      <PermissableMenuItem
        className="mr-1"
        size="small"
        onClick={() => methods.toggleVendorDetailsDrawer(record)}
        required_permission="VENDOR_READ"
      >
        View Details
      </PermissableMenuItem>
      {/* {
       (((record.approval || {}).id && record.status_label === "unapproved") || (!((record.approval || {}).id) && record.status_label === "active")) ? (
          <PermissableMenuItem
            className="mr-1"
            size="small"
            onClick={() => methods.toggleVendorModal({ ...record, is_edit: true })}
            required_permission="VENDOR_WRITE"
            disabled={(((record.approval || {}).id && record.status_label === "unapproved") || (!((record.approval || {}).id) && record.status_label === "active")) ? false : true}
          >
            Edit
          </PermissableMenuItem>
        ) : null
      } */}

      <PermissableMenuItem
        className="mr-1"
        size="small"
        onClick={() => methods.toggleVendorModal({ ...record, is_edit: true })}
        required_permission="VENDOR_WRITE"
        disabled={(((record.approval || {}).id && record.status_label === "unapproved") || (!((record.approval || {}).id) && record.status_label === "active")) ? false : true}
      >
        Edit
      </PermissableMenuItem>


    </Menu>
  );
};

export const getVendorColumns = (methods, current_user) => [
  {
    title: "Name",
    key: "vendor_name",
    render: (record) => <Text4>{record.name || "---"}</Text4>,
  },
  {
    title: "Email ID",
    key: "email",
    render: (record) => (
      <div className="d-flex flex-column">
        <Text4>{record.email || "---"}</Text4>
      </div>
    ),
  },
  {
    title: "Phone No.",
    key: "phone",
    render: (record) => (
      <div className="d-flex flex-column">
        <Text4>{record.phone || "---"}</Text4>
      </div>
    ),
  },
  {
    title: (
      <span className="c-pointer" onClick={methods.toggleStatusInfoDrawer}>
        <span>Vendor Status</span>
        <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
      </span>
    ),
    key: "status",
    render: (record) => (
      <Badge color={VENDOR_APPROVAL_STATUS[record.status].color} text={<Text4>{record.status && VENDOR_APPROVAL_STATUS[record.status].label || "---"}</Text4>} />
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <Dropdown overlay={renderMenuOverlay(methods, record)}>
        <Button>
          Actions <Icon type="down" />
        </Button>
      </Dropdown>
    ),
  },
];

export const vendorTableFilterNodes = () => {
  return [
    {
      label: "Name",
      field: "name",
      placeholder: "Name",
      inputType: "text",
      defaultValue: undefined,
      disabled: false,
    },
    {
      label: "Email",
      field: "email",
      placeholder: "Email",
      inputType: "text",
      width: 200,
      disabled: false,
      defaultValue: undefined,
    },
    {
      label: "Phone",
      field: "phone",
      placeholder: "Phone",
      inputType: "text",
      defaultValue: "",
    },
  ];
};
